export default __webpack_public_path__ + "locale/ru/6bef9a07.json";